module.exports = __webpack_public_path__ + "img/DCS_0779-45.53d2af83.jpg";